import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { TaskStatus } from '@/types/productFeed';
import SubTask from '@/components/SubTask';
import { step4SubTaskNameConstants } from '@/lib/constants/subTaskNameConstants';
import DownloadReportField from '@/components/DownloadReportField';
import { Badge } from '@/components/ui/badge';

interface Step4CompletionProps {
  vendor?: string;
  onProceedWithFeaturesCategorization: () => void;
  stepFourTasks?: TaskStatus;
}

const Step4Completion: React.FC<Step4CompletionProps> = ({
  vendor,
  onProceedWithFeaturesCategorization,
  stepFourTasks
}) => {
  const subTasks = stepFourTasks?.subTasks || [];
  const rawFeedReportGeneratedTask = subTasks.find(task => task?.task === step4SubTaskNameConstants.rawFeedReportGenerate);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Sub Tasks Section */}
      <SubTask subTasks={subTasks} />

      {/* Status Section */}
      <Card className="bg-white border border-gray-200 shadow-sm">
        <CardHeader>
          <CardTitle className="text-lg font-semibold">Status</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Product Type & SubType Categorization */}
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">Product Type & SubType Categorization</h3>
            </div>

            {/* Download Report Button */}
            <DownloadReportField
              status={rawFeedReportGeneratedTask?.status?.toLowerCase() || 'pending'}
              rawProductFeedValidationReportLocation={rawFeedReportGeneratedTask?.ReportLocation}
            />

            {/* Proceed with Features Categorization Button */}
            <Button
              onClick={onProceedWithFeaturesCategorization}
              className="w-full bg-green-600 hover:bg-green-700 text-white flex items-center justify-center gap-2"
            >
              Proceed with Features Categorization
              <ArrowRight className="h-4 w-4" />
            </Button>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Status:</span>
                <Badge className="bg-blue-100 text-blue-700">{stepFourTasks?.status || 'Pending'}</Badge>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Step4Completion; 